import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { PurchasedSalesPackage } from 'app/main/models/purchasedSalesPackage/purchasedSalesPackage.model';
import { RatingService } from 'app/main/services/rating.service';
import { SalesPackageService } from 'app/main/services/salespackage.service';
import { AlertComponentComponent } from 'app/main/shared/alert/alert-component/alert-component.component';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';

@Component({
  selector: 'app-new-rating',
  templateUrl: './new-rating.component.html',
  styleUrls: ['./new-rating.component.scss']
})
export class NewRatingComponent implements OnInit {

  punctualityVote: any;
  clarityVote: any;
  professionalismVote: any;
  active: any;
  message: any;
  color: string;

  dialog: any;
  professor: any;
  showStar: boolean;

  fakeRanking: any;
  isAdmin: boolean;

  purchasedSalesPackage: PurchasedSalesPackage;

  constructor(
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<NewRatingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ratingService: RatingService,
    private loaderService: LoaderService,
    private salesPackageService: SalesPackageService,
    private localAccountService: LocalAccountService
  ) {
  }


  async ngOnInit() {
    if (this.localAccountService.isAdmin()) {
      this.professor = this.data.professor;
      await this.initializeForAdmin();
      this.isAdmin = true;
    } else {
      this.punctualityVote = 0;
      this.clarityVote = 0;
      this.professionalismVote = 0;
      this.initializeForStudent();
      this.isAdmin = false;
    }
  }

  initializeForStudent() {
    this.purchasedSalesPackage = this.data.purchasedSalesPackage;
    this.color = this.salesPackageService.retrieveSalespackageColor(this.purchasedSalesPackage.salesPackage);
    this.showStar = true;
  }

  async initializeForAdmin() {
    this.color = '#e18f0a';
    this.loaderService.showLoader();
    const resp: any = await this.ratingService.getFakeRating(this.professor.id).catch((err) => {
      console.error(err);
      this.loaderService.hideLoader();
    });
    if (resp) {
      if (resp.ok) {
        if (resp.payload) {
          this.fakeRanking = resp.payload;
          this.punctualityVote = this.getElement('PUNCTUALITY', resp.payload);
          this.clarityVote = this.getElement('CLARITY', resp.payload);
          this.professionalismVote = this.getElement('PROFESSIONALISM', resp.payload);
          this.active = resp.payload.active;
          this.showStar = true;
          this.loaderService.hideLoader();
        } else {
          this.punctualityVote = 0;
          this.clarityVote = 0;
          this.professionalismVote = 0;
          this.active = false;
          this.showStar = true;
          this.loaderService.hideLoader();
        }
      }
    }
  }

  getElement(type, resp) {
    let val = null;
    for (let x = 0; x < resp.averageProfessorRankingItems.length; x++) {
      if (resp.averageProfessorRankingItems[x].type === type) {
        val = resp.averageProfessorRankingItems[x].value;
        return val;
      }
    }
  }



  async saveRating(isAdmin) {
    if (!this.punctualityVote || !this.clarityVote || !this.professionalismVote) {
      let message = 'Hai assegnato 0 a ';
      if (!this.punctualityVote) {
        if (!this.clarityVote && !this.professionalismVote) {
          message = message + 'puntualit&agrave;, ';
        } else if ((!this.clarityVote && this.professionalismVote) || (this.clarityVote && !this.professionalismVote)) {
          message = message + 'puntualit&agrave; e ';
        } else if (this.clarityVote && this.professionalismVote) {
          message = message + 'puntualit&agrave;.';
        }
      }
      if (!this.clarityVote) {
        if (!this.punctualityVote && !this.professionalismVote) {
          message = message + 'chiarezza e ';
        } else if (this.punctualityVote && !this.professionalismVote) {
          message = message + 'chiarezza e ';
        } else {
          message = message + 'chiarezza.';
        }
      }
      if (!this.professionalismVote) {
        message = message + 'professionalit&agrave;';
      }
      const dialog = this.matDialog.open(AlertComponentComponent, {
        data: {
          innerHTML: true,
          title: message,
          buttons: [
            {
              innerHTML: true,
              body: 'Conferma Voto',
              color: 'primary',
              close: true,
              value: true,
              callback: async () => {
                const obj: any = this.buildObj(isAdmin);
                this.dialogRef.close({
                  data: obj
                });
              }
            },
            {
              text: 'Annulla',
              close: true,
              value: false,
              callback: () => {
              }
            }
          ]
        }
      });
      return await dialog.afterClosed().toPromise();
    } else {
      const obj: any = this.buildObj(isAdmin);
      this.dialogRef.close({
        data: obj
      });
    }
  }

  setMessage(message) {
    this.message = message;
  }

  vote(standard, vote) {
    switch (standard) {
      case 'PUNCTUALITY': {
        if (this.punctualityVote === vote) {
          return this.punctualityVote = 0;
        } else {
          return this.punctualityVote = vote;
        }
      }
      case 'CLARITY': {
        if (this.clarityVote === vote) {
          return this.clarityVote = 0;
        } else {
          return this.clarityVote = vote;
        }
      }
      case 'PROFESSIONALISM': {
        if (this.professionalismVote === vote) {
          this.professionalismVote = 0;
        } else {
          return this.professionalismVote = vote;
        }
      }
    }
  }

  buildObj(isAdmin) {
    const obj: any = {};
    if (isAdmin) {
      obj.id = this.fakeRanking.id;
      obj.professorId = this.professor.id;
      obj.active = this.active;
      obj.averageProfessorRankingItems = [
        {
          type: 'PUNCTUALITY',
          value: this.punctualityVote
        },
        {
          type: 'CLARITY',
          value: this.clarityVote
        },
        {
          type: 'PROFESSIONALISM',
          value: this.professionalismVote
        }
      ];
    } else {
      obj.purchasedSalesPackageId = this.purchasedSalesPackage.id;
      obj.rankingItems = [
        {
          type: 'PUNCTUALITY',
          value: this.punctualityVote
        },
        {
          type: 'CLARITY',
          value: this.clarityVote
        },
        {
          type: 'PROFESSIONALISM',
          value: this.professionalismVote
        }
      ];
      obj.description = this.message;
    }
    return obj;
  }
}
